import {Component} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {
    DxDateRangeBoxComponent,
    DxFileUploaderComponent,
    DxFormComponent,
    DxTextAreaComponent,
    DxValidatorComponent
} from "devextreme-angular";
import {DxiItemComponent, DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {PicturedItemSelectBoxComponent} from "../../../../../components";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import TimeOffPopupComponent from "../../time-off-popup.component";
import {
    AccessType,
    AgencyTimeOffGridViewDto, ChangeAgencyTimeOffStatusCommand, CreateAgencyTimeOffCommand, EmployeeDto,
    PermissionType, TimeOffStatus
} from "@services";
import {FileUtils} from 'src/app/shared/file-utils';

@Component({
    selector: 'app-agency-time-off-popup',
    imports: [
        AsyncPipe,
        DxDateRangeBoxComponent,
        DxFormComponent,
        DxTextAreaComponent,
        DxValidatorComponent,
        DxiItemComponent,
        DxiValidationRuleComponent,
        PicturedItemSelectBoxComponent,
        TimeOffRequestModalComponent,
        DxFileUploaderComponent
    ],
    templateUrl: './agency-time-off-popup.component.html',
})
export class AgencyTimeOffPopupComponent extends TimeOffPopupComponent<AgencyTimeOffGridViewDto> {
    override employeesDataSource = this.dataSources.employeeOptions(PermissionType.AgencyTimeOffRequests);
    files: File[] = [];

    async onSave() {
        const uploadedFiles = await FileUtils.mapFilesToDto(this.files);

        let createCommand = new CreateAgencyTimeOffCommand({
            requestedStartDate: this.formData.requestedStartDate,
            requestedEndDate: this.formData.requestedEndDate,
            userId: this.formData.employee.id,
            description: this.formData.description,
            uploadedFiles: uploadedFiles
        });

        this.timeOffClient.createAgencyTimeOff(createCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    async loadData() {
        if (this.request) {
            this.formData = new AgencyTimeOffGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new AgencyTimeOffGridViewDto();
            this.formData.init({
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto()
            });
            this.formData.requestedStartDate = null;
            this.formData.requestedEndDate = null
        }
        this.employeeId.next(this.formData.employee.id);
        this.startDate.next(this.formData.requestedStartDate);
        this.endDate.next(this.formData.requestedEndDate);
    }

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangeAgencyTimeOffStatusCommand({
            id: this.formData.id,
            status: status
        });

        this.timeOffClient.changeAgencyTimeOffStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.AgencyTimeOffRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.AgencyTimeOffRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.AgencyTimeOffRequests, AccessType.Manage);
    }
}
